import React from "react"
import { Mail, MapPin, Phone } from "lucide-react"
import { FacebookIcon, TiktokIcon } from "../../../components/icons"

interface TutimiFooterProps {
  className?: string
}

/**
 * TUTIMI Footer Component
 * Replicates the exact layout and styling from the original TUTIMI footer
 * with 100% visual fidelity using Tailwind CSS
 */
const socialLinks = [
  {
    href: "https://www.facebook.com/nhahangchaythientruc",
    label: "Theo dõi Thiền Trúc trên Facebook",
    icon: FacebookIcon,
  },
]

const contactInfo = [
  {
    icon: Mail,
    text: "Email: thientruc@gmail.com",
  },
  {
    icon: MapPin,
    text: "4/4 Đường Số 3, P. Hiệp Bình, TP. Thủ Đức\n41/5 Trần Nhật Duật, P. Tân Định, TP.HCM",
  },
  {
    icon: Phone,
    text: "0772 777 007 (Thiền Trúc - Thủ Đức)\n0906 830 248 (Thiền Trúc Premium - Tân Định)",
  },
]

const policyLinks = [
  {
    href: "/policy#privacy-policy",
    text: "– Quy chế hoạt động và Chính sách bảo mật.",
  },
  {
    href: "/policy#terms-of-service",
    text: "– Điều khoản sử dụng dịch vụ.",
  },
  {
    href: "/policy#food-safety-policy",
    text: "– Chính sách an toàn thực phẩm.",
  },
]

const TutimiFooter: React.FC<TutimiFooterProps> = ({ className = "" }) => {
  return (
    <div className={className}>
      {/* Main Footer */}
      <footer
        className="relative pb-4 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('/background-footer.jpg')",
        }}
        role="contentinfo"
      >
        {/* Overlay for better text readability */}
        {/* <div className="absolute inset-0 bg-black/5"></div> */}
        <div className="relative max-w-[1380px] mx-auto px-4 z-10 text-primary">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-4">
            {/* Column 1: Company Info & Social Media */}
            <div className="lg:px-4 text-left text-xl lg:text-left">
              <div className="mb-6">
                <div className="mb-4">
                  <img
                    loading="lazy"
                    decoding="async"
                    className="mx-auto lg:mx-0 h-auto w-auto max-w-[200px] lg:max-w-[300px] object-contain"
                    src="/logos/tutimi-text-white.png"
                    alt="THIEN TRUC Logo"
                    width="250"
                    height="80"
                  />
                </div>
              </div>
            </div>

            {/* Column 2: Contact Info & Policies */}
            <div className="lg:px-4 mt-6 lg:mt-8">
              <div className="mb-6">
                <h4 className=" font-bold uppercase mb-4 text-lg text-left lg:text-left">
                  LIÊN HỆ
                </h4>
                <ul className="space-y-3  text-start">
                  {contactInfo.map((item, index) => (
                    <li
                      key={index}
                      className="flex items-start justify-start gap-2"
                    >
                      <item.icon size={17} className=" mt-0.5 flex-shrink-0" />
                      <span className="whitespace-pre-line">{item.text}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* <div className="text-left lg:text-left">
                <h4 className=" font-bold uppercase mb-4 text-lg">
                  HỖ TRỢ VÀ CHÍNH SÁCH
                </h4>
                <ul className="space-y-2 text-left">
                  {policyLinks.map((link, index) => (
                    <li key={index}>
                      <a>{link.text}</a>
                    </li>
                  ))}
                </ul>
              </div> */}
            </div>

            {/* Column 3: TuTiMi Footer Image */}
            {/* <div className="lg:px-4 flex items-center justify-center">
              <img
                src="/web-ttmi/homepage/tutimi-footer.png"
                className="max-w-[848px] max-h-[294px] w-full h-auto object-contain rounded-lg"
                alt="TuTiMi Footer"
                decoding="async"
                loading="lazy"
              />
            </div> */}
          </div>
          <div className="max-w-[calc(1380px/3*2-2rem)] lg:max-w-[calc(1380px/3*2-1rem)]">
            <h4 className=" font-bold uppercase mb-4 text-lg">VỀ THIỀN TRÚC</h4>
            <p className=" leading-relaxed mb-6 text-left">
              VỊ CHAY MỚI MẺ - SỨC KHOẺ TỰ NHIÊN
              <br />
              Thiền Trúc không ngừng theo đuổi sứ mệnh mang phong vị mới từ
              những vùng đất trứ danh tại Việt Nam và trên thế giới đến khách
              hàng.
            </p>
            {/* Social Media */}
            <div className="flex justify-center lg:justify-start gap-4">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className="text-primary transition-colors duration-300"
                  aria-label={link.label}
                  target="_blank"
                >
                  <link.icon size={24} />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Copyright Section - Full Width Border */}
        <div className="mt-8 pt-6 border-t border-white/20 w-full">
          <div className="max-w-[1380px] mx-auto px-4">
            <div className="text-center">
              <p className="text-primary text-sm italic">
                ©Thiền Trúc 2025 | All rights reserved. Website by Thiền Trúc.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default TutimiFooter
